import React, { useEffect, useState, useRef } from 'react'
import ApiUrl from '../../../../../configTools/apiUrl';

const Recommendations = ({recommendations,setRecommendations}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const recommendationsPop = useRef(null);
    const [recommendationsList,setRecommendationsList] = useState([]);
    const [recommendationsFilter,setRecommendationsFilter] = useState([]);
    const removeRecommendation = (e) =>{
        let recommendationsArray = recommendations.filter((item)=> {
          return item.id !== e.id
        })
        setRecommendations(recommendationsArray);
    }
    const addRecommendation = (e)=>{
      if(recommendations.length > 8){
        return;
      }
      var recommendationsArray = [];
      for (let index = 0; index < recommendations.length; index++) {
          const item = recommendations[index];
          recommendationsArray.push(item);
      }
      recommendationsArray.push(e);
      setRecommendations(recommendationsArray);
    }
  
    const recommendationsPopUp = ()=>{
      recommendationsPop.current.className = "listing_recommendations_popup_wrapper active";
    }
    const recommendationsPopDown = ()=>{
      recommendationsPop.current.className = "listing_recommendations_popup_wrapper";
    }
    useEffect(()=>{
        let filteredrecommendations = recommendationsList.filter((item)=> {
          return !recommendations.find((itemB)=> {
            return item.id === itemB.id;
          })
        })
        setRecommendationsFilter(filteredrecommendations);
    },[recommendations])
    useEffect(() => {
        fetch(ApiUrl.API_URL_ListingUser+"/"+User.username)
        .then(res=>res.json())
        .then(data =>{
            if(data.success)
            setRecommendationsList(data.responce);
            setRecommendationsFilter(data.responce);
        });
    },[])
  return (
    <>
        <div className='admin_forms_multirow'>
            <div className='admin_col_33' onClick={recommendationsPopUp}>
                <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "3px",
                        border: "2px dashed black",
                        position: "relative"
                    }}>
                        <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                            <p>Add</p>
                        </div>
                    </div>
                </label>
            </div>
            {
            recommendations.map((item,index)=>{
                return(
                <div className='admin_col_33' key={index}>
                    <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}>
                        <div className='product_image_remove' onClick={()=>{
                        removeRecommendation(item);
                        }}>X</div>
                    </div>
                    </label>
                </div>
                )
            })
            }
        </div>
        <div className='listing_recommendations_popup_wrapper' ref={recommendationsPop} style={{zIndex:"10003"}}>
        <div className='listing_recommendations_popup_container'>
            <div style={{
            padding:"20px 0px",
            width:"100%",
            display:"flex",
            justifyContent:"flex-end"
            }}>
            <p style={{
                padding:"10px"
            }} onClick={recommendationsPopDown}>X</p>
            </div>
                {
                recommendationsFilter.map((item,index)=>{
                    return(
                    <div className='admin_col_33' key={index} onClick={()=>{
                        addRecommendation(item);
                        recommendationsPopDown();
                    }}>
                        <label style={{cursor:"pointer"}}>
                                <div style={{
                                    width: "100%",
                                    paddingTop: "80%",
                                    borderRadius: "10px",
                                    position: "relative",
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}>
                                </div>
                        </label>
                    </div>
                    )
                })
                }
        </div>
        </div>
    </>
  )
}

export default Recommendations
